export type CreditComparisonRow = {
  id: string
  criterion: string
  condominiumCredit: string
  extraordinaryFee: string
}

export const creditComparisonRows: CreditComparisonRow[] = [
  {
    id: 'how-it-works',
    criterion: 'Como funciona',
    condominiumCredit:
      'O condomínio obtém os recursos por meio de uma operação de crédito estruturada e paga conforme o contrato.',
    extraordinaryFee: 'Os moradores contribuem diretamente para formar os recursos do projeto.'
  },
  {
    id: 'what-to-evaluate',
    criterion: 'O que avaliar',
    condominiumCredit: 'Valor da operação, parcelas, prazo, custo total e capacidade de pagamento.',
    extraordinaryFee: 'Adesão, prazo de arrecadação e impacto imediato nas finanças das unidades.'
  }
]
